import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const s3PresignedCategoryUrl = async (file, fileExtension, fileType) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const s3Response = await axios.get(`${API_URL}/company/bodyAndMind/categories/generateUrl/${fileExtension}/${fileType}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });

    const fullUrl = s3Response.data.url;
    const storedUrl = fullUrl.substring(0, fullUrl.indexOf("?"));
    const uuid = s3Response.data.uuid;

    await axios.put(fullUrl, file, {
        headers: { "Content-Type": file.type }
    });

    return { storedUrl, uuid };
};
